<template>
  <v-menu offset-y style="z-index: 10000">
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon :ripple="false" v-bind="attrs" v-on="on">
        <audi-icon icon="languages" dark/>
      </v-btn>
    </template>
    <v-list>
      <v-list-item
        v-for="(language, index) in languages"
        :key="index"
        @click="translateTo(language)"
      >
        <v-list-item-title>{{ language.name }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import AudiIcon from '@/components/audi/AudiIcon.vue';

export default {
  name: 'LanguageSelector',
  components: { AudiIcon },
  props: {},
  data() {
    return {};
  },
  computed: {
    languages() {
      return [
        { name: 'English', code: 'en' },
        { name: 'Deutsch', code: 'de' },
        { name: 'Italiano', code: 'it' },
        { name: 'Français', code: 'fr' },
      ].sort((a, b) => a.name.localeCompare(b.name));
    },
  },
  methods: {
    translateTo(language) {
      this.$emit('change');
      this.$store.dispatch('translateToWithoutDB', language.code);
    },
  },
}
</script>

<style scoped>

</style>
